import Dialog from '../../dialog/Dialog';
import strings from '../../../translations';
import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { useAppSelector } from '../../../state/hooks';
import FeatureDataDownload from '../download/FeatureDataDownload';

import { setIsGfiDownloadOpen } from '../../../state/slices/uiSlice';

import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { GFI_GEOMETRY_LAYER_ID } from '../../../utils/constants';

const FeatureDataDownloadDialog = () => {
  const { store } = useContext(ReactReduxContext);
  const channel = useAppSelector((state) => state.rpc.channel);

  const isGfiOpen = useAppSelector((state) => state.ui.isGfiOpen);
  const isGfiDownloadOpen = useAppSelector(
    (state) => state.ui.isGfiDownloadOpen
  );

  const handleCloseGfiDownloadDialog = () => {
    store.dispatch(setIsGfiDownloadOpen(false));

    // If gfi window is closed, remove features, otherwise there's no way to erase them afterwards
    !isGfiOpen &&
      channel &&
      channel.postRequest('MapModulePlugin.RemoveFeaturesFromMapRequest', [
        null,
        null,
        GFI_GEOMETRY_LAYER_ID
      ]);
  };

  return isGfiDownloadOpen ? (
    <Dialog
      drag={true} /* Enable (true) or disable (false) drag */
      resize={false}
      fullScreenOnMobile={
        true
      } /* Scale dialog full width / height when using mobile device */
      titleIcon={faDownload} /* Use icon on title or null */
      title={strings.downloads.downloads} /* Dialog header title */
      type={'normal'} /* Dialog type */
      closeAction={
        handleCloseGfiDownloadDialog
      } /* Action when pressing dialog close button or backdrop */
      id="gfi_download_dialog"
    >
      <FeatureDataDownload />
    </Dialog>
  ) : null;
};

export default FeatureDataDownloadDialog;
